<template>
  <CommonList :config="config" :listData="emoticonListWithMoment"/>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { MODULE_NAME as PGM_MODULE, FETCH_EMOTICON_LIST} from '@/store/playGame/actions.type'
import { $showModalWithErrorMsg } from '@/common/util'
import { SHOW_MODAL } from '@/store/ui/mutations.type'
import CommonList from '@/views/PlayGame/components/CommonList.vue'
export default {
	components : {
		CommonList
	},
	mounted () {
		this.$store.dispatch(PGM_MODULE + FETCH_EMOTICON_LIST)
			.catch($showModalWithErrorMsg.bind(this))
	},
	data () {
		return {
			config : {
				type : 'playGameEmoticon',
				header : '이모티콘'
			}
		}
	},
	methods : {
		...mapMutations('ui', [SHOW_MODAL])
	},
	computed : {
		...mapGetters(PGM_MODULE, [
			'emoticonListWithMoment'
		]),
	},
}
</script>
